  /*=========================================================================================
  File Name: state.js
  Description: Categories State
  ----------------------------------------------------------------------------------------
  Item Name: Categories State Module
  Author: Tan Tran
==========================================================================================*/

export default {
    categories: [],
}